// Formatação da tela. As datas do SGP chegam como texto no horário local do
// provedor e são montadas por partes: `new Date('2026-05-20')` é UTC, e no
// Brasil voltaria como dia 19.

const MOEDA = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

export const dinheiro = valor => MOEDA.format(Number(valor) || 0);

// "2026-08-10" → "10/08/2026"
export const data = iso => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ''));
  return m ? `${m[3]}/${m[2]}/${m[1]}` : '—';
};

// "2026-09-01T11:18:34", "2026-09-03 07:12:55" ou "01/09/2026 11:17:17"
export const momento = bruto => {
  const texto = String(bruto || '').trim();
  const m = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/.exec(texto);
  if (m) return `${m[3]}/${m[2]}/${m[1]} ${m[4]}:${m[5]}`;
  return /^\d{2}\/\d{2}\/\d{4}/.test(texto) ? texto : '—';
};

// Hoje e hoje + N dias como "AAAA-MM-DD", pelo calendário local.
export const hojeMais = dias => {
  const agora = new Date();
  const d = new Date(
    agora.getFullYear(),
    agora.getMonth(),
    agora.getDate() + dias
  );
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${mm}-${dd}`;
};

// Segundos de sessão → "2 d 7 h", que é como o suporte fala.
export const duracao = segundos => {
  const s = Math.max(0, Math.trunc(Number(segundos) || 0));
  if (s < 60) return `${s} s`;
  const dias = Math.floor(s / 86400);
  const horas = Math.floor((s % 86400) / 3600);
  const min = Math.floor((s % 3600) / 60);
  if (dias > 0) return `${dias} d ${horas} h`;
  if (horas > 0) return `${horas} h ${min} min`;
  return `${min} min`;
};

export const bytes = valor => {
  let n = Math.max(0, Number(valor) || 0);
  if (n < 1024) return `${Math.trunc(n)} B`;
  const unidades = ['KB', 'MB', 'GB', 'TB'];
  let i = -1;
  while (n >= 1024 && i < unidades.length - 1) {
    n /= 1024;
    i += 1;
  }
  return `${n.toFixed(n >= 100 ? 0 : 1).replace('.', ',')} ${unidades[i]}`;
};

// "529.982.247-25" enquanto digita.
export const mascaraDocumento = bruto => {
  const d = String(bruto || '')
    .replace(/\D/g, '')
    .slice(0, 14);
  if (d.length <= 11) {
    return d
      .replace(/^(\d{3})(\d)/, '$1.$2')
      .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3-$4');
  }
  return d
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3/$4')
    .replace(/^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d)/, '$1.$2.$3/$4-$5');
};
